module.exports = __webpack_public_path__ + "static/img/course05.94afcbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course05.jpg
// module id = mapb
// module chunks = 101